import { render } from "./VueNotificationList.vue?vue&type=template&id=e1ef80b2&scoped=true"
import script from "./VueNotificationList.vue?vue&type=script&lang=ts"
export * from "./VueNotificationList.vue?vue&type=script&lang=ts"

import "./VueNotificationList.vue?vue&type=style&index=0&id=e1ef80b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e1ef80b2"

export default script